import { Injectable, NgZone } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../../state/modules/auth/services/auth.service';
@Injectable()
export class MessagingService {
  currentMessage = new BehaviorSubject(null);

  /**
   * Firebase messaging callbacks are delivered outside the Angular zone, so the
   * handlers below re-enter it before touching app state / `currentMessage`,
   * otherwise notification-driven UI updates only show on the next interaction.
   */
  constructor(private angularFireMessaging: AngularFireMessaging, private authService: AuthService, private readonly zone: NgZone) {
  }

  requestPermission() {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        // console.log(token, 'messaging token');
        this.zone.run(() => {
          this.authService.saveNotificationToken({ user_access_token_device_type: 'web', user_access_token_fcm_token: token }).subscribe();
        });
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }

  receiveMessage() {

    this.angularFireMessaging.messages.subscribe(
      (payload: any) => this.zone.run(() => {

        // console.log('new message received. ', payload);
        payload.data.click_action = payload.notification.click_action;
        const NotificationOptions = {
          body: payload.notification.body,
          data: payload.data,
          icon: payload.notification.icon,
        };
        navigator.serviceWorker.getRegistration('/firebase-cloud-messaging-push-scope').then(registration => {
          registration.showNotification(payload.notification.title, NotificationOptions);
        });
        this.currentMessage.next(payload);
      }));
  }
}
